import { render, staticRenderFns } from "./ClinicsTable.vue?vue&type=template&id=421c7a8a&"
import script from "./ClinicsTable.vue?vue&type=script&lang=js&"
export * from "./ClinicsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports